/**
 * PATH: packages/drafting/src/canvas/DraftPreview.tsx
 * FILE_ID: DRAFTING-CANVAS-DRAFTPREVIEW-001
 * PURPOSE: The live, non-committed shape shown while a create tool is
 *   being dragged (rect/circle/line/dimension/leader). Render-only.
 */
import { Rect, Line, Group } from 'react-konva'
import type { Point } from '../ir/schema'
import type { Tool } from '../hooks/useDrafting'

export interface DraftState {
  kind: Tool
  start: Point
  current: Point
}

export function DraftPreview({ draft }: { draft: DraftState }) {
  const { kind, start, current } = draft
  if (kind === 'rect') {
    return (
      <Rect
        x={Math.min(start[0], current[0])}
        y={Math.min(start[1], current[1])}
        width={Math.abs(current[0] - start[0])}
        height={Math.abs(current[1] - start[1])}
        stroke="#2563eb"
        dash={[4, 4]}
        strokeScaleEnabled={false}
        listening={false}
      />
    )
  }
  if (kind === 'circle') {
    return (
      <Group listening={false}>
        <Line points={[start[0], start[1], current[0], current[1]]} stroke="#93c5fd" strokeScaleEnabled={false} />
        <Rect x={start[0] - 1} y={start[1] - 1} width={2} height={2} fill="#2563eb" />
      </Group>
    )
  }
  return (
    <Line
      points={[start[0], start[1], current[0], current[1]]}
      stroke="#2563eb"
      dash={[4, 4]}
      strokeScaleEnabled={false}
      listening={false}
    />
  )
}
